import { isMemberSubscriptionTicketPrice } from '../../utils/tickets/ticket-price-utils';
import { getTicketPricesForShowtime } from './get-ticket-prices-for-showtime';
export const getTicketPricesForMemberSubscription = (showtimeId, subscriptionId) => {
    const ticketPrices = getTicketPricesForShowtime(showtimeId);
    if (!ticketPrices)
        return [];
    const filteredPrices = ticketPrices.filter(price => {
        if (!isMemberSubscriptionTicketPrice(price))
            return false;
        return price.subscriptionId === subscriptionId;
    });
    return filteredPrices;
};
